export const SERVICE_ALIAS = {
    AION: 'aion'
};

export const SERVER_TYPE = {
    [SERVICE_ALIAS.AION]: {
        LIVE: 'LIVE',
        CLASSIC: 'CLASSIC'
    }
};

const CONTI_ALIAS = {
    [SERVICE_ALIAS.AION]: {
        [SERVER_TYPE[SERVICE_ALIAS.AION].LIVE]: 'schedule-live-group',
        [SERVER_TYPE[SERVICE_ALIAS.AION].CLASSIC]: 'schedule-classic-group'
    }
};

export const getLanguage = () => {
    return window?.userData?.locale?.split('-')[0]?.toLowerCase()
    || document.querySelector('html')?.lang
    || 'ko';
};

export const getCountry = () => {
    return window?.userData?.locale?.split('-')[1]?.toLowerCase()
    || document.querySelector('html')?.dataset?.country
    || 'kr';
};

export const getContiAlias = (serviceAlias: typeof SERVICE_ALIAS[keyof typeof SERVICE_ALIAS], serverType?: string) => {
    switch(serviceAlias) {
        case SERVICE_ALIAS.AION:
            return serverType ? CONTI_ALIAS[serviceAlias][serverType] : null;
        default:
            return null;
    }
};